import { Radio } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import userAPI from "../api/userAPI";
import swalDialog from "../helpers/swalErrorPopup";
import MastercardNew from "../img/svg/Mastercard_new.svg";
import MultipleEntryPassCard from "../img/svg/multiple-entry-pass-card.svg";
import MultipleEntryPassCardOvdimBari from "../img/svg/multiple-entry-pass-card-ovdimbari.svg";
import { isLoadChanger } from "../store/mainSlice";
import { isPartnerClalit, isPartnerOvdimBari } from "../store/partnerStore";
import clubAPI from "../api/clubAPI";
import { updateAllAppParams } from "../store/appParamSlice";
import {
  addNewMultipleEntryPass,
  checkCanPurchasePass,
  hasActiveMultipleEntryPassSelector,
} from "../store/multipleEntryPassSlice";
import "../styles/multipleEntryPassPurchase.scss";

const MultipleEntryPassPurchase = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();

  const paymentLabelRef = useRef();

  const hasActiveMultipleEntryPass = useSelector(hasActiveMultipleEntryPassSelector);

  const userParams = useSelector((state) => state.userSlice.userData);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const isHaveCard = useSelector((state) => state.userSlice.isHaveCreditCard);
  const isClalit = useSelector(isPartnerClalit);
  const isOvdimBari = useSelector(isPartnerOvdimBari);

  // Local state
  const [last4Digit, setLast4Digit] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("multipleEntryPass");

  useEffect(() => {
    checkIsHasCreditCard();
  }, []);

  const checkIsHasCreditCard = async () => {
    try {
      dispatch(isLoadChanger(true));

      let isHaveCreditCard = await userAPI.isClientHaveCreditCard({
        token: mainUserParams.Token,
        id: mainUserParams.ID,
        phone: mainUserParams.Phone,
      });

      if (isHaveCreditCard.data.Error != 0) {
        throw {
          code: isHaveCreditCard.data.Error,
          mess: isHaveCreditCard.data.Message,
        };
      }

      const jsonData = JSON.parse(isHaveCreditCard.data.Data);
      setLast4Digit(jsonData.Last4Digit);

      if (jsonData.HasCreditCard && jsonData.Last4Digit) {
        setSelectedPaymentMethod("creditCard");
      }

      dispatch(isLoadChanger(false));
    } catch (err) {
      dispatch(isLoadChanger(false));
      swalDialog(err);
    }
  };

  const handlePaymentMethodChange = (method) => {
    setSelectedPaymentMethod(method);
  };

  const handlePayment = async () => {
    try {
      dispatch(isLoadChanger(true));
      const result = await userAPI.purchaseMultipleEntryPass({
        token: mainUserParams.Token,
        id: mainUserParams.ID,
        phone: mainUserParams.Phone,
        passPlanId: isOvdimBari ? 2 : 1,
      });
      dispatch(addNewMultipleEntryPass(result));
      dispatch(
        checkCanPurchasePass({
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        }),
      );

      if (isOvdimBari) {
        try {
          const param = await clubAPI.getWebFullData({
            binID: userParams.BinID,
            token: mainUserParams.Token,
            id: mainUserParams.ID,
            phone: mainUserParams.Phone,
          });
          if (param.data.Error !== 0) {
            throw { code: param.data.Error, mess: param.data.Message };
          }
          dispatch(updateAllAppParams(JSON.parse(param.data.Data)));
        } catch (err) {
          swalDialog(err);
        }
      }

      dispatch(isLoadChanger(false));

      navigate("/multipleEntryPass", { replace: true });
    } catch (error) {
      dispatch(isLoadChanger(false));
      swalDialog(error);
      return;
    }
  };

  const calculatePrice = () => (isOvdimBari ? 160 : 90);

  const getExpirationDate = () => {
    return moment().add(5, "year").format("DD/MM/YYYY");
  };

  return (
    <div className="main-page-container">
      <div className={`multiple-entry-pass-purchase${isOvdimBari ? " multiple-entry-pass-purchase--ovdim-bari" : ""}`}>
        <div>
          <img src={isClalit ? MultipleEntryPassCard : MultipleEntryPassCardOvdimBari}></img>
        </div>
        <div className="multiple-entry-pass-purchase__bottom-popup">
          <div className="multiple-entry-pass-purchase__bottom-popup__content">
            <div className="popup-content-wrapper">
              <div>
                <div className="mobile-popup-header">
                  <p className="mobile-popup-header-text">{t("MULTIPLE_ENTRY_PASS_DETAILS")}</p>
                </div>
                <div className={"mobile-popup-header-info"}>
                  <p style={{ direction: "rtl" }}>{t("MULTIPLE_ENTRY_PASS_ALL_UNIVERSAL_LOCATIONS")}</p>
                  <>{t("EXPIRES_ON", { date: getExpirationDate() })}</>
                </div>
              </div>
              <div className="mobile-popup-content-wrapper">
                <div className="mobile-popup-text-content-container">
                  {(!isClalit || (isClalit && !hasActiveMultipleEntryPass)) && (
                    <div className="mobile-popup-payment-method-container">
                      <div className="mobile-popup-card-number">
                        <span className="card-dots">●●●●</span>
                        <span className="card-number">{last4Digit}</span>
                        <img src={MastercardNew} alt="" className="card-logo" />
                      </div>
                      <div className="radio-btn-container">
                        <p className="credit-card">{t("CREDIT_CARD")}</p>
                        <Radio checked />
                      </div>
                    </div>
                  )}

                  <div className="mobile-popup-text-footer">
                    <p className="mobile-popup-text-thin">{t("TOTAL_PRICE")}:</p>
                    {calculatePrice() > 0 && <p>₪{calculatePrice()}</p>}
                  </div>
                </div>
              </div>
            </div>
            <div className="mobile-popup-btn-block">
              <button
                onClick={() => handlePayment()}
                style={{ fontSize: "18px", fontWeight: 700, width: "100%" }}
                className={"main-page-btn big-button very-big-button lightred-btn"}
              >
                {t("PAYMENT")}
              </button>
              {/* {isClalit && <PoweredBy />} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultipleEntryPassPurchase;
